import { render, staticRenderFns } from "./CommitmentFull.vue?vue&type=template&id=0b271e2d"
import script from "./CommitmentFull.vue?vue&type=script&lang=js"
export * from "./CommitmentFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports